(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWcondor_atlas_", frames: [[558,533,80,148],[302,524,80,148],[384,633,118,80],[640,627,118,80],[846,639,110,82],[77,646,110,82],[260,674,96,84],[504,683,96,84],[602,709,86,88],[690,709,86,88],[917,0,90,148],[210,524,90,148],[778,683,64,98],[958,639,64,98],[640,533,124,92],[844,723,88,54],[766,547,78,134],[388,357,168,182],[558,357,140,174],[700,357,140,174],[384,541,118,90],[846,547,114,90],[77,556,108,88],[0,556,75,136],[0,694,74,56],[358,715,100,74],[964,357,60,92],[189,674,69,126],[733,0,182,134],[842,357,120,188],[512,155,454,200],[0,346,208,208],[210,346,176,176],[0,155,510,189],[0,0,731,153]]}
];


// symbols:



(lib.CondorBackLeg0001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CondorBackLeg0002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0010001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0010002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0030001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0030002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0050001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0050002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0070001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CondorHead_0070002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CondorLeg0001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CondorLeg0002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CondorNeck20001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CondorNeck20002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CondorNeckFeathers = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CondorNeckPiece = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CondorTail = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CondorTorso = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CondorWing0001 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CondorWing0002 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanChestFeather2 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanChestFeathers1 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanChestFeathers3 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanLeftLeg = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanNeckFeathers2 = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanNeckFeathers = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanNeck = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanRightLeg = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanTail = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanTorso = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.CondorWingspanWing = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.Tween1kh = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.Tween2khb = function() {
	this.spriteSheet = ss["MWcondor_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.Tween2khb_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Tween2khb();
	this.instance.parent = this;
	this.instance.setTransform(-182.6,-37.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-182.8,-40.7,365.7,81.3);


(lib.Tween1kh_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Tween1kh();
	this.instance.parent = this;
	this.instance.setTransform(-127.4,-45.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-127.4,-57.7,255,115.2);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.CondorWingspanWing_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.CondorWingspanWing();
	this.instance.parent = this;
	this.instance.setTransform(-3.9,-1.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanWing_1, new cjs.Rectangle(-3.9,-1.9,227,100), null);


(lib.CondorWingspanTorso_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanTorso();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanTorso_1, new cjs.Rectangle(-3,-2,60,94), null);


(lib.CondorWingspanTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanTail();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanTail_1, new cjs.Rectangle(-4,-3,92,68), null);


(lib.CondorWingspanRightLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanRightLeg();
	this.instance.parent = this;
	this.instance.setTransform(-2.9,-2.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanRightLeg_1, new cjs.Rectangle(-4,-3,36.5,64.8), null);


(lib.CondorWingspanNeckFeathers2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanNeckFeathers2();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanNeckFeathers2_1, new cjs.Rectangle(-3,-2,37,28), null);


(lib.CondorWingspanNeckFeathers_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanNeckFeathers();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanNeckFeathers_1, new cjs.Rectangle(-3,-2,50,37), null);


(lib.CondorWingspanNeck_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanNeck();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanNeck_1, new cjs.Rectangle(-3,-2,30,46), null);


(lib.CondorWingspanLeftLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanLeftLeg();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanLeftLeg_1, new cjs.Rectangle(-7,-7,41.3,71.8), null);


(lib.CondorWingspanChestFeathers3_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanChestFeathers3();
	this.instance.parent = this;
	this.instance.setTransform(-3.2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanChestFeathers3_1, new cjs.Rectangle(-3.2,-2,54,44), null);


(lib.CondorWingspanChestFeathers1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanChestFeathers1();
	this.instance.parent = this;
	this.instance.setTransform(-3,-1.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanChestFeathers1_1, new cjs.Rectangle(-3,-1.9,57,45), null);


(lib.CondorWingspanChestFeather2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorWingspanChestFeather2();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorWingspanChestFeather2_1, new cjs.Rectangle(-3,-2,59,45), null);


(lib.CondorUpperBeak_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFCC00").s().p("AgKA4QgTgcgegCQgegDACgJQAEgKASglQASgnA2AEQA3AEANArIANAqIgcAFQgdAFgLAaQgGANgHAAQgHAAgKgOg");
	this.shape.setTransform(7.8,7.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorUpperBeak_007, new cjs.Rectangle(-1,0.2,17.6,14), null);


(lib.CondorLowerBeak_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFCC00").s().p("AgjAaQgqgLABgVQAAgUAYgDQAGAAATACQBLgCAQAHQAMAEABAJQAEAjg6ADIgTABQgTAAgUgEg");
	this.shape.setTransform(5,1.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorLowerBeak_007, new cjs.Rectangle(-2.7,-1.6,15.5,5.9), null);


(lib.CondorHeadshape_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF9999").s().p("AgCBvQhegGgPgrQgQgqAIghQAIgiATgdQATgeA+gEQA9gFAfAfQAeAeAHAlQAHAkgEAdQgEAdgzAVQgfAOgdAAIgIgBg");
	this.shape.setTransform(12.2,11);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorHeadshape_007, new cjs.Rectangle(0,-0.1,24.5,22.3), null);


(lib.CondorEye_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgIAAQABgHAHAAQAIAAAAAHQAAACgCADQgDADgDAAQgHAAgBgIg");
	this.shape.setTransform(3.5,1.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AgCAbQgXgCgCgQQgBgMAHgKQAHgJAOgDQAOgDAIAIQAIAIgDAMQgFAbgWAAIgCAAgAgBgHQAAAHAIAAQADAAADgCQACgDAAgCQAAgIgIAAQgIAAAAAIg");
	this.shape_1.setTransform(2.8,2.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorEye_001, new cjs.Rectangle(0,0,5.6,5.4), null);


(lib.condor_neckGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("AAng/QAXA9AVAeQAVAegZAVQgZAVgtANQgsAMgSgOQgSgPgFgiQgFgjAAgKIgHh0QgOgGApgDQApgDASgGQARgHAYA9g");
	this.shape.setTransform(9.4,19.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.condor_neckGlow, new cjs.Rectangle(-1.3,6.6,21.5,26.7), null);


(lib.condor_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(2,1,1).p("AArhQQAMB2gggNQgggMgDgOQAAgcgMhFIgtAKQAjBigoAPIhOALQgTADgFAYQgGAZBegVIAAAWQgRgDANACQAKACAbAFIAMgCQAIABAJgDQALgEASgIQABAEACAFQALAOAWgDQAAAAAagSQAbgRAKAAQAKAAAWACQAWADARgLQASgKg0gPQg0gQAEgWQADgWACgaQACgZgOgBQgOgBgbAAg");
	this.shape.setTransform(18.3,17.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.condor_footGlow, new cjs.Rectangle(-0.5,6.2,37.6,21.9), null);


(lib.condor_eyelids2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F47979").s().p("AgWAWQgJgJAAgNQAAgMAJgJQAKgKAMABQANgBAJAKQAJAJAAAMQAAANgJAJQgJAKgNAAQgMAAgKgKg");
	this.shape.setTransform(3.2,3.7);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#F47979").s().p("AgWAWQgJgJAAgNQAAgMAJgJQAKgKAMABQANgBAJAKQAJAJAAAMQAAANgJAJQgJAKgNAAQgMAAgKgKg");
	this.shape_1.setTransform(17.5,3.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.condor_eyelids2, new cjs.Rectangle(0,0,20.7,6.9), null);


(lib.condor_eyelids = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F47979").s().p("AgWAWQgFgFgCgHIgBgCIgBgGQAfAGAfgGIAAAGIgBACQgCAHgGAFQgJAKgNAAQgMAAgKgKgAgegDIAAgDQACgIAGgHQAKgJAMAAQANAAAJAJQAHAHACAIIAAADQgggJgdAJg");
	this.shape.setTransform(3.2,3.7);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#F47979").s().p("AgVAWQgIgHgBgLQAeALAfgLQgBALgIAHQgJAJgNAAQgMAAgJgJgAgegCQABgLAIgJQAJgJAMAAQANAAAJAJQAJAJAAALQgcgIghAIg");
	this.shape_1.setTransform(17.5,3.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.condor_eyelids, new cjs.Rectangle(0,0,20.7,6.8), null);


(lib.condor_beakGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("AAgAxQgUADgRgCQgbgCgGgDQgIgEgGAHQgDAFgCADQgCAEgCgBQgRgEAEgtQAEgcAYgTQAWgSAcgDQAdgDATAOQAWAPAAAeQAAAGACAKQABAIgFADQACAGgMAHQgLAGgTAFg");
	this.shape.setTransform(7.6,5.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.condor_beakGlow, new cjs.Rectangle(-1.5,-1.5,18.2,14.9), null);


(lib.condor_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3.5,1,1).p("ADTBhQApBggEAhQgEAig9gWQg8gWhqhWQhphVhYhTQhXhTAUgLQATgKAagXQAagXACgkQACgkA6AZQA6AaAjAYQAhAYAlAbQAlAcAoA3QAoA1ApBfg");
	this.shape.setTransform(27.9,27.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.condor_backGlow, new cjs.Rectangle(1.4,1.4,53.1,52.8), null);


(lib.blueglowneck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AAng/QAXA9AVAeQAVAegZAVQgZAVgtANQgsAMgSgOQgSgPgFgiQgFgjAAgKIgHh0QgOgGApgDQApgDASgGQARgHAYA9g");
	this.shape.setTransform(9.4,19.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowneck, new cjs.Rectangle(-1.3,6.6,21.5,26.7), null);


(lib.blueglowfeet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(2,1,1).p("AArhQQAMB2gggNQgggMgDgOQAAgcgMhFIgtAKQAjBigoAPIhOALQgTADgFAYQgGAZBegVIAAAWQgRgDANACQAKACAbAFIAMgCQAIABAJgDQALgEASgIQABAEACAFQALAOAWgDQAAAAAagSQAbgRAKAAQAKAAAWACQAWADARgLQASgKg0gPQg0gQAEgWQADgWACgaQACgZgOgBQgOgBgbAAg");
	this.shape.setTransform(18.3,17.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowfeet, new cjs.Rectangle(-0.5,6.2,37.6,21.9), null);


(lib.blueglowbeak = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AAgAxQgUADgRgCQgbgCgGgDQgIgEgGAHQgDAFgCADQgCAEgCgBQgRgEAEgtQAEgcAYgTQAWgSAcgDQAdgDATAOQAWAPAAAeQAAAGACAKQABAIgFADQACAGgMAHQgLAGgTAFg");
	this.shape.setTransform(7.6,5.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowbeak, new cjs.Rectangle(-1.5,-1.5,18.2,14.9), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3.5,1,1).p("ADTBhQApBggEAhQgEAig9gWQg8gWhqhWQhphVhYhTQhXhTAUgLQATgKAagXQAagXACgkQACgkA6AZQA6AaAjAYQAhAYAlAbQAlAcAoA3QAoA1ApBfg");
	this.shape.setTransform(27.9,27.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(1.4,1.4,53.1,52.8), null);


(lib.CondorTorso_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorTorso();
	this.instance.parent = this;
	this.instance.setTransform(-40,-43.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorTorso_1, new cjs.Rectangle(-40,-43.2,84,91), null);


(lib.CondorTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorTail();
	this.instance.parent = this;
	this.instance.setTransform(-17.5,-31.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorTail_1, new cjs.Rectangle(-17.5,-31.4,39,67), null);


(lib.CondorNeckPiece_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorNeckPiece();
	this.instance.parent = this;
	this.instance.setTransform(-21.7,-10.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorNeckPiece_1, new cjs.Rectangle(-21.7,-10.8,44,27), null);


(lib.CondorNeckFeathers_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CondorNeckFeathers();
	this.instance.parent = this;
	this.instance.setTransform(-27.7,-18.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CondorNeckFeathers_1, new cjs.Rectangle(-27.7,-18.5,62,46.1), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.condor_beakMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:27,clean:50});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_27 = function() {
		/* stop();*/
	}
	this.frame_50 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(27).call(this.frame_27).wait(23).call(this.frame_50).wait(11));

	// Layer 5
	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(7.7,3.2,0.482,0.482,33.7,0,0,47.6,10.2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(27).to({_off:false},0).to({_off:true},23).wait(11));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAwAlIABgEIgBAAQgKAAgIgNQgDAHgFADQAAAJgJAAQgGAAgEgCQgDgDAAgFIAAgIIgDgBQgTAFgEABQgPAAAAgNIABgHIgFAAIAAACQAAAFgGAAQgGAAAAgGQAAgBAAAAQAAgBAAgBQABAAAAgBQAAAAAAAAQgEgDAAgEQAAgSABgDQAGgQAbgBQAkAAAWAOQASALAAALIAAABQADACAEAIIACANQAAAJgEAEQAFAAAAAFQABAGgHAAQgGAAAAgFg");
	this.shape.setTransform(6.1,4.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},21).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,12.1,8.5);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.CondorWing_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wash:0,wash_stop:60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(15.9,-0.8,0.674,0.674,-112,0,0,35.9,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(1.6,-23,0.654,0.654,-169.3,0,0,35.8,11.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(53));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CondorWing = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,"clean":2,clean_loop:3,glow:4,glow_loop:5,"wash":6,"wash_stop":61,glowclean:127,glowclean_loop:128,"final":129,final_loop:130});

	// Layer 5
	this.instance = new lib.CondorWing0001();
	this.instance.parent = this;
	this.instance.setTransform(-31.5,-41.5,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(3.3,-2.9,0.749,0.749,60,0,0,50.6,5.2);

	this.instance_2 = new lib.CondorWing0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-31.5,-41.5,0.5,0.5);

	this.instance_3 = new lib.condor_backGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-0.1,-5,1.241,1.241,8.2,0,0,27.9,27.8);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(-0.1,-5,1.241,1.241,8.2,0,0,27.9,27.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},6).to({state:[{t:this.instance_2},{t:this.instance_1}]},49).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},66).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(125));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.2,-41.5,70.8,87);


(lib.CondorNeck2_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":50});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-10.6,-3.2,0.654,0.654,61.2,0,0,35.8,11.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},49).wait(42));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CondorNeck2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":62,"glowclean":88,"glowclean_loop":89,"final":90,"final_loop":91});

	// Layer 4
	this.instance = new lib.CondorNeck20001();
	this.instance.parent = this;
	this.instance.setTransform(-14.2,-28.5,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-4.1,-2.3,0.75,0.75,90,0,0,47.6,10);

	this.instance_2 = new lib.CondorNeck20002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-14.2,-28.5,0.5,0.5);

	this.instance_3 = new lib.condor_neckGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-1.3,-4.1,1.268,1.625,0,1.9,10.2,9.2,19.8);

	this.glow = new lib.blueglowneck();
	this.glow.parent = this;
	this.glow.setTransform(-1.3,-4.1,1.268,1.625,0,1.9,10.2,9.2,19.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},6).to({state:[{t:this.instance_2},{t:this.instance_1}]},50).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},26).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(164));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-14.2,-28.5,32,49);


(lib.CondorLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":61,"glowclean":87,"glowclean_loop":88,"final":89,"final_loop":90});

	// Layer 5
	this.instance = new lib.CondorLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-25.9,-22.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-0.3,37.7,0.5,0.5,0,0,0,48.8,4.8);

	this.instance_2 = new lib.CondorLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-25.9,-22.9,0.5,0.5);

	this.instance_3 = new lib.condor_footGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-8.7,31.5,1.279,1.414,7.2,0,0,18.2,17.2);

	this.glow = new lib.blueglowfeet();
	this.glow.parent = this;
	this.glow.setTransform(-8.7,31.5,1.279,1.414,7.2,0,0,18.2,17.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},23).to({state:[{t:this.instance_2},{t:this.instance_1}]},32).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},26).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(165));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-40,-22.9,59.1,87.5);


(lib.CondorHead_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":117,"glowclean_loop":118,"final":119,"final_loop":120});

	// Layer 2
	this.instance = new lib.CondorHead_0050001();
	this.instance.parent = this;
	this.instance.setTransform(-23.2,-15.5,0.5,0.5);

	this.instance_1 = new lib.CondorHead_0050002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-23.2,-15.5,0.5,0.5);

	this.instance_2 = new lib.condor_beakGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(3.4,5.4,1.066,1.243,0,0,180,7.5,5.9);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(3.4,6.5,1.1,1.1,0,0,180,7.5,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.glow}]},111).to({state:[{t:this.instance_1}]},2).to({state:[]},2).to({state:[]},1).wait(133));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23.2,-15.5,48,42);


(lib.CondorHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":67,"glowclean_loop":68,"final":69,"final_loop":70});

	// Layer 2
	this.instance = new lib.CondorHead_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-23,-15.5,0.5,0.5);

	this.instance_1 = new lib.CondorHead_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-23,-15.5,0.5,0.5);

	this.instance_2 = new lib.condor_beakGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(11.1,5.3,1.066,1.066,0,0,180,7.5,5.9);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(11.4,5.3,1.066,1.066,0,0,180,7.5,5.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.glow}]},61).to({state:[{t:this.instance_1}]},2).to({state:[]},7).to({state:[]},1).wait(128));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23.2,-15.5,55.2,41.1);


(lib.CondorHead_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":45});

	// Beak
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(22,4.7,0.441,0.441,-112,0,0,35.8,11.2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},44).wait(48));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CondorHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":117,"glowclean_loop":118,"final":119,"final_loop":120});

	// Layer 2
	this.instance = new lib.CondorHead_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-23,-15.5,0.5,0.5);

	this.instance_1 = new lib.CondorHead_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-23,-15.5,0.5,0.5);

	this.instance_2 = new lib.condor_beakGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(15.9,5.3,1.066,1.066,0,0,180,7.5,5.9);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(15.9,5.3,1.066,1.066,0,0,180,7.5,5.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},54).to({state:[{t:this.instance_1},{t:this.glow}]},57).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(135));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23.2,-15.5,59.2,40);


(lib.CondorBackLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-20.8,35.6,0.435,0.435,-82,0,0,35.6,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7.6,43,0.435,0.435,-82,0,0,35.6,11.2);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-1.2,42.3,0.435,0.435,-112,0,0,36.2,11.2);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-4.5,40.7,0.257,0.257,-169.3,0,0,35.9,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).to({state:[]},1).wait(10));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CondorBackLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":225,"glowclean":226,"glowclean_loop":227,"final":228,"final_loop":229});

	// Layer 5
	this.instance = new lib.CondorBackLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-19.5,-21.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(1.7,38.5,0.5,0.5,0,0,0,47.6,10.2);

	this.instance_2 = new lib.CondorBackLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-19.5,-21.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},53).to({state:[{t:this.instance_2},{t:this.instance_1}]},167).to({state:[{t:this.instance_2}]},2).to({state:[]},2).to({state:[]},22).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-38.4,-21.9,58.9,86.5);


(lib.water_drops_013 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(162.9,-11.6,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(96.6,26.1,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(84.9,46.5,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(151.3,15.9,0.486,0.486,0,0,0,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(132.4,26.9,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,17,18,23);


(lib.CondorBeak_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.condor_beakMud_001();
	this.instance.parent = this;
	this.instance.setTransform(8.7,6.3,1.123,1.274,0,-4,-15,6,4.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 1
	this.instance_1 = new lib.CondorUpperBeak_007();
	this.instance_1.parent = this;
	this.instance_1.setTransform(10.3,8.5,1,1,0,0,0,9.6,8.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,3);

	this.instance_2 = new lib.CondorLowerBeak_007();
	this.instance_2.parent = this;
	this.instance_2.setTransform(9.6,11,1,1,0,0,0,6.4,2.7);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.3,-3.4,29,25);


(lib.CondorHead_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":117,"glowclean_loop":118,"final":119,"final_loop":120});

	// Layer 2
	this.instance = new lib.CondorHead_0070001();
	this.instance.parent = this;
	this.instance.setTransform(-22.5,-16,0.5,0.5);

	this.instance_1 = new lib.CondorHead_0070002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-22.5,-16,0.5,0.5);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},111).to({state:[{t:this.instance_1}]},2).to({state:[]},2).to({state:[]},1).wait(133));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2).to({_off:false},0).to({_off:true},2).wait(2).to({_off:false},0).wait(113).to({_off:true},2).wait(134));

	// Beak
	this.instance_2 = new lib.CondorBeak_007("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(-4.4,9.1,1.107,1.107,0,0,0,8.6,8.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({_off:true},2).wait(253));

	// Layer 4
	this.instance_3 = new lib.CondorEye_001();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-12,-2.8,1.028,1.028,0,0,0,3,1.8);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,3);

	this.instance_4 = new lib.CondorEye_001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(3.4,-1.9,1.028,1.028,0,0,0,2.8,2.6);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).to({state:[]},2).wait(253));

	// Face
	this.instance_5 = new lib.CondorHeadshape_007();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-4.3,0.6,1.107,1.107,0,0,0,12.9,11.1);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},2).wait(253));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-16,43.2,44);


(lib.Condor = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:36,rest_stop:182,wet:184,wet_stop:196,"clean":198,clean_stop:220,excited:222,excited_stop:290,animalSound:292});

	// timeline functions:
	this.frame_34 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_182 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_196 = function() {
		/* stop();
		
		*/
	}
	this.frame_220 = function() {
		/* stop();
		
		*/
	}
	this.frame_290 = function() {
		/* 
		
		
		
		gameObjects._game.done();
		
		stop();*/
	}
	this.frame_326 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(34).call(this.frame_34).wait(148).call(this.frame_182).wait(14).call(this.frame_196).wait(24).call(this.frame_220).wait(70).call(this.frame_290).wait(36).call(this.frame_326).wait(1));

	// Layer 7
	this.instance = new lib.condor_eyelids();
	this.instance.parent = this;
	this.instance.setTransform(309.3,41.5,1,1,0,0,0,10.3,3.4);

	this.instance_1 = new lib.condor_eyelids2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(309.3,41.5,1,1,0,0,0,10.3,3.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},90).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},4).to({state:[]},2).wait(229));

	// legs bubbles
	this.legs_bubbles = new lib.CondorBackLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(350.4,135.4,1,1,0,0,0,-24.2,35.4);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(36).to({_off:true},148).wait(143));

	// Condor Head_001
	this.beak_bubbles = new lib.CondorHead_001_bubbles();
	this.beak_bubbles.parent = this;
	this.beak_bubbles.setTransform(327.3,34.2,0.918,0.918,0,7.6,-172.4);

	this.timeline.addTween(cjs.Tween.get(this.beak_bubbles).wait(36).to({_off:true},148).wait(143));

	// Condor Neck 2
	this.neck_bubbles = new lib.CondorNeck2_bubbles();
	this.neck_bubbles.parent = this;
	this.neck_bubbles.setTransform(341.4,59.1,0.832,0.832,-7.4);

	this.timeline.addTween(cjs.Tween.get(this.neck_bubbles).wait(36).to({_off:true},148).wait(143));

	// Condor Wing
	this.back_bubbles = new lib.CondorWing_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(379.2,98.9,0.832,0.832,-7.4);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(36).to({_off:true},148).wait(143));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(414.4,49.4,0.75,0.75);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(262).to({_off:false},0).to({_off:true},30).wait(35));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(472.1,73.5,0.75,0.75);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(282).to({_off:false},0).to({_off:true},10).wait(35));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(401.3,83.6,0.75,0.75);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(240).to({_off:false},0).to({_off:true},52).wait(35));

	// sparkle
	this.instance_5 = new lib.sparkle();
	this.instance_5.parent = this;
	this.instance_5.setTransform(344.8,93.4,0.75,0.75);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(250).to({_off:false},0).to({_off:true},42).wait(35));

	// sparkle
	this.instance_6 = new lib.sparkle();
	this.instance_6.parent = this;
	this.instance_6.setTransform(344.6,13.9,0.75,0.75);
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(268).to({_off:false},0).to({_off:true},24).wait(35));

	// water
	this.instance_7 = new lib.water_drops_013();
	this.instance_7.parent = this;
	this.instance_7.setTransform(383.1,96.6,0.6,0.6,0,0,180,92.4,49.1);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(184).to({_off:false},0).to({_off:true},14).wait(129));

	// sparkle
	this.instance_8 = new lib.sparkle();
	this.instance_8.parent = this;
	this.instance_8.setTransform(232.5,57.7,0.75,0.75);
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(244).to({_off:false},0).to({_off:true},48).wait(35));

	// Condor Wingspan Head
	this.condor_head = new lib.CondorHead_001();
	this.condor_head.parent = this;
	this.condor_head.setTransform(327.3,34.2,0.918,0.918,0,7.6,-172.4);

	this.condor_head_1 = new lib.CondorHead_003();
	this.condor_head_1.parent = this;
	this.condor_head_1.setTransform(320,37.3,0.918,0.918,0,4.3,-175.7);
	this.condor_head_1._off = true;

	this.condor_head_2 = new lib.CondorHead_005();
	this.condor_head_2.parent = this;
	this.condor_head_2.setTransform(312.6,40.4,0.918,0.918,0,1,-179);
	this.condor_head_2._off = true;

	this.condor_head_3 = new lib.CondorHead_007();
	this.condor_head_3.parent = this;
	this.condor_head_3.setTransform(305.3,43.5,0.918,0.918,0,-2.1,177.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.condor_head}]}).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head_1}]},2).to({state:[{t:this.condor_head_2}]},2).to({state:[{t:this.condor_head_3,p:{regX:0,regY:0,scaleX:0.918,scaleY:0.918,rotation:0,skewX:-2.1,skewY:177.9,x:305.3,y:43.5}}]},2).to({state:[{t:this.condor_head_2}]},10).to({state:[{t:this.condor_head_1}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},6).to({state:[{t:this.condor_head}]},10).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head_1}]},2).to({state:[{t:this.condor_head_2}]},2).to({state:[{t:this.condor_head_3,p:{regX:0,regY:0,scaleX:0.918,scaleY:0.918,rotation:0,skewX:-2.1,skewY:177.9,x:305.3,y:43.5}}]},2).to({state:[{t:this.condor_head_2}]},82).to({state:[{t:this.condor_head_1}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},38).to({state:[{t:this.condor_head}]},14).to({state:[{t:this.condor_head}]},26).to({state:[{t:this.condor_head_1}]},2).to({state:[{t:this.condor_head_2}]},2).to({state:[{t:this.condor_head_3,p:{regX:8.3,regY:18.6,scaleX:0.908,scaleY:0.908,rotation:2.7,skewX:0,skewY:0,x:368.2,y:45.4}}]},2).to({state:[{t:this.condor_head_2}]},2).to({state:[{t:this.condor_head}]},2).to({state:[{t:this.condor_head}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.condor_head).wait(2).to({skewX:8.3,skewY:-171.7,x:328.7,y:33.5},0).wait(2).to({skewX:9.3,skewY:-170.7,x:330.1,y:32.8},0).wait(2).to({skewX:11.1,skewY:-168.9,x:332.8,y:31.3},0).wait(2).to({skewX:7.6,skewY:-172.4,x:327.3,y:34.2},0).to({_off:true},2).wait(18).to({_off:false},0).wait(18).to({skewX:8.3,skewY:-171.7,x:328.7,y:33.5},0).wait(2).to({skewX:9.3,skewY:-170.7,x:330.1,y:32.8},0).wait(2).to({skewX:11.1,skewY:-168.9,x:332.8,y:31.3},0).wait(2).to({skewX:7.6,skewY:-172.4,x:327.3,y:34.2},0).to({_off:true},2).wait(90).to({_off:false},0).wait(80).to({_off:true},2).wait(8).to({_off:false,rotation:-7.6,skewX:0,skewY:0,x:359.2,y:16.7},0).wait(58).to({rotation:0,skewX:7.6,skewY:-172.4,x:327.3,y:34.2},0).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.condor_head_1).wait(10).to({_off:false},0).to({_off:true},2).wait(14).to({_off:false},0).to({_off:true},2).wait(26).to({_off:false},0).to({_off:true},2).wait(86).to({_off:false},0).to({_off:true},2).wait(82).to({_off:false,skewX:3,skewY:-177,x:329.8,y:36.4},0).to({_off:true},2).wait(99));
	this.timeline.addTween(cjs.Tween.get(this.condor_head_2).wait(12).to({_off:false},0).to({_off:true},2).wait(10).to({_off:false},0).to({_off:true},2).wait(30).to({_off:false},0).to({_off:true},2).wait(82).to({_off:false},0).to({_off:true},2).wait(86).to({_off:false,skewX:-1.4,skewY:-181.4,x:332.3,y:38.6},0).to({_off:true},2).wait(2).to({_off:false,regX:8.5,regY:18.2,scaleX:0.91,scaleY:0.91,rotation:-5.8,skewX:0,skewY:-360,x:371.9,y:39.1},0).to({_off:true},2).wait(93));

	// Condor Wingspan Neck Feathers 2
	this._null = new lib.CondorNeckPiece_1();
	this._null.parent = this;
	this._null.setTransform(342.9,67.7,0.734,0.734,-22.4);

	this._null_1 = new lib.CondorWingspanNeckFeathers2_1();
	this._null_1.parent = this;
	this._null_1.setTransform(356.5,53.5,0.888,0.888,0,0,0,14.5,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this._null}]}).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},10).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},6).to({state:[{t:this._null}]},10).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},82).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},38).to({state:[{t:this._null}]},14).to({state:[{t:this._null}]},26).to({state:[{t:this._null}]},2).to({state:[{t:this._null}]},2).to({state:[{t:this._null_1,p:{y:53.5,regY:10.1}}]},2).to({state:[{t:this._null_1,p:{y:52,regY:10.1}}]},2).to({state:[{t:this._null_1,p:{y:50.5,regY:10}}]},2).to({state:[{t:this._null}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this._null).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-21.3,x:343.7,y:67.3},0).wait(2).to({rotation:-20.6,x:344.6,y:66.7},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-18.9,x:346.4,y:65.6},0).wait(2).to({rotation:-22.4,x:342.9,y:67.7},0).wait(2).to({scaleX:0.77,scaleY:0.73,rotation:-25.1,x:340.4,y:68.9},0).wait(2).to({scaleX:0.81,rotation:-28,x:337.8,y:70.1},0).wait(2).to({scaleX:0.84,scaleY:0.73,rotation:-30.8,x:335.3,y:71.3},0).wait(10).to({scaleX:0.81,scaleY:0.73,rotation:-28,x:337.8,y:70.1},0).wait(2).to({scaleX:0.77,rotation:-25.1,x:340.4,y:68.9},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-22.4,x:342.9,y:67.7},0).wait(18).to({scaleX:0.73,scaleY:0.73,rotation:-21.3,x:343.7,y:67.3},0).wait(2).to({rotation:-20.6,x:344.6,y:66.7},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-18.9,x:346.4,y:65.6},0).wait(2).to({rotation:-22.4,x:342.9,y:67.7},0).wait(2).to({scaleX:0.77,scaleY:0.73,rotation:-25.1,x:340.4,y:68.9},0).wait(2).to({scaleX:0.81,rotation:-28,x:337.8,y:70.1},0).wait(2).to({scaleX:0.84,scaleY:0.73,rotation:-30.8,x:335.3,y:71.3},0).wait(82).to({scaleX:0.81,scaleY:0.73,rotation:-28,x:337.8,y:70.1},0).wait(2).to({scaleX:0.77,rotation:-25.1,x:340.4,y:68.9},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-22.4,x:342.9,y:67.7},0).wait(80).to({x:344.4},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-22.3,x:346.6,y:68},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-22.4,x:349,y:68.2},0).to({_off:true},2).wait(62).to({_off:false,x:342.9,y:67.7},0).wait(35));

	// Condor Wingspan Neck
	this.condor_neck = new lib.CondorNeck2();
	this.condor_neck.parent = this;
	this.condor_neck.setTransform(341.4,59.1,0.832,0.832,-7.4);

	this.condor_neck_1 = new lib.CondorWingspanNeck_1();
	this.condor_neck_1.parent = this;
	this.condor_neck_1.setTransform(356.8,51.6,0.888,0.608,0,9.7,0,9.4,34.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.condor_neck}]}).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},10).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},6).to({state:[{t:this.condor_neck}]},10).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},82).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},38).to({state:[{t:this.condor_neck}]},14).to({state:[{t:this.condor_neck}]},26).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck}]},2).to({state:[{t:this.condor_neck_1,p:{regX:9.4,scaleY:0.608,skewX:9.7,x:356.8}}]},2).to({state:[{t:this.condor_neck_1,p:{regX:9.5,scaleY:0.748,skewX:4.8,x:356.9}}]},2).to({state:[{t:this.condor_neck_1,p:{regX:9.4,scaleY:0.888,skewX:0,x:356.8}}]},2).to({state:[{t:this.condor_neck}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.condor_neck).wait(2).to({rotation:-6.3,x:342.4,y:58.5},0).wait(2).to({rotation:-5.5,x:343.4,y:58},0).wait(2).to({rotation:-3.9,x:345.4,y:56.9},0).wait(2).to({rotation:-7.4,x:341.4,y:59.1},0).wait(2).to({rotation:-17.6,x:337.6,y:60.6},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-28,x:333.9,y:62.2},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-38.3,x:330.1,y:63.8},0).wait(10).to({scaleX:0.83,scaleY:0.83,rotation:-28,x:333.9,y:62.2},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-17.6,x:337.6,y:60.6},0).wait(2).to({rotation:-7.4,x:341.4,y:59.1},0).wait(18).to({rotation:-6.3,x:342.4,y:58.5},0).wait(2).to({rotation:-5.5,x:343.4,y:58},0).wait(2).to({rotation:-3.9,x:345.4,y:56.9},0).wait(2).to({rotation:-7.4,x:341.4,y:59.1},0).wait(2).to({rotation:-17.6,x:337.6,y:60.6},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-28,x:333.9,y:62.2},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-38.3,x:330.1,y:63.8},0).wait(82).to({scaleX:0.83,scaleY:0.83,rotation:-28,x:333.9,y:62.2},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-17.6,x:337.6,y:60.6},0).wait(2).to({rotation:-7.4,x:341.4,y:59.1},0).wait(82).to({rotation:-7.3,x:344.1,y:58.5},0).wait(2).to({rotation:-7.4,x:346.8,y:57.9},0).to({_off:true},2).wait(62).to({_off:false,x:341.4,y:59.1},0).wait(35));

	// Condor Wingspan Neck Feathers
	this.instance_9 = new lib.CondorNeckFeathers_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(347,70.5,0.734,0.734,-22.4);

	this.instance_10 = new lib.CondorWingspanNeckFeathers_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(358,59.5,0.888,0.888,0,0,0,21.2,14.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9}]}).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},10).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},6).to({state:[{t:this.instance_9}]},10).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},82).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},38).to({state:[{t:this.instance_9}]},14).to({state:[{t:this.instance_9}]},26).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10,p:{regY:14.6,y:59.5}}]},2).to({state:[{t:this.instance_10,p:{regY:14.5,y:57.3}}]},2).to({state:[{t:this.instance_10,p:{regY:14.5,y:55.2}}]},2).to({state:[{t:this.instance_9}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-21.3,x:347.9,y:70},0).wait(2).to({rotation:-20.6,x:348.7,y:69.5},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-18.9,x:350.4,y:68.6},0).wait(2).to({rotation:-22.4,x:347,y:70.5},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-28.1,x:344.3,y:71.9},0).wait(2).to({rotation:-33.9,x:341.5,y:73.5},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-39.8,x:338.9,y:75},0).wait(10).to({scaleX:0.73,scaleY:0.73,rotation:-33.9,x:341.5,y:73.5},0).wait(2).to({rotation:-28.1,x:344.3,y:71.9},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-22.4,x:347,y:70.5},0).wait(18).to({scaleX:0.73,scaleY:0.73,rotation:-21.3,x:347.9,y:70},0).wait(2).to({rotation:-20.6,x:348.7,y:69.5},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-18.9,x:350.4,y:68.6},0).wait(2).to({rotation:-22.4,x:347,y:70.5},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-28.1,x:344.3,y:71.9},0).wait(2).to({rotation:-33.9,x:341.5,y:73.5},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-39.8,x:338.9,y:75},0).wait(82).to({scaleX:0.73,scaleY:0.73,rotation:-33.9,x:341.5,y:73.5},0).wait(2).to({rotation:-28.1,x:344.3,y:71.9},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-22.4,x:347,y:70.5},0).wait(82).to({scaleX:0.73,scaleY:0.73,rotation:-22.3,x:349.3,y:70.7},0).wait(2).to({scaleX:0.73,scaleY:0.73,rotation:-22.4,x:351.6,y:70.9},0).to({_off:true},2).wait(62).to({_off:false,x:347,y:70.5},0).wait(35));

	// Condor Wingspan Chest Feathers 1
	this.condor_torso = new lib.CondorWing();
	this.condor_torso.parent = this;
	this.condor_torso.setTransform(379.2,98.9,0.832,0.832,-7.4);

	this.condor_torso_1 = new lib.CondorWingspanChestFeathers1_1();
	this.condor_torso_1.parent = this;
	this.condor_torso_1.setTransform(357.7,81.3,0.888,0.888,0,0,0,24.4,18.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.condor_torso}]}).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},10).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},6).to({state:[{t:this.condor_torso}]},10).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},82).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},38).to({state:[{t:this.condor_torso}]},14).to({state:[{t:this.condor_torso}]},26).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso}]},2).to({state:[{t:this.condor_torso_1,p:{y:81.3}}]},2).to({state:[{t:this.condor_torso_1,p:{y:78.9}}]},2).to({state:[{t:this.condor_torso_1,p:{y:76.5}}]},2).to({state:[{t:this.condor_torso}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.condor_torso).wait(2).to({rotation:-6.3,x:379.6},0).wait(2).to({rotation:-5.5,x:380},0).wait(2).to({rotation:-3.9,x:380.7},0).wait(2).to({rotation:-7.4,x:379.2},0).wait(2).to({rotation:-13.6,x:379.6,y:97.1},0).wait(2).to({rotation:-19.8,x:379.9,y:95.3},0).wait(2).to({rotation:-26.3,x:380.3,y:93.6},0).wait(10).to({rotation:-19.8,x:379.9,y:95.3},0).wait(2).to({rotation:-13.6,x:379.6,y:97.1},0).wait(2).to({rotation:-7.4,x:379.2,y:98.9},0).wait(18).to({rotation:-6.3,x:379.6},0).wait(2).to({rotation:-5.5,x:380},0).wait(2).to({rotation:-3.9,x:380.7},0).wait(2).to({rotation:-7.4,x:379.2},0).wait(2).to({rotation:-13.6,x:379.6,y:97.1},0).wait(2).to({rotation:-19.8,x:379.9,y:95.3},0).wait(2).to({rotation:-26.3,x:380.3,y:93.6},0).wait(82).to({rotation:-19.8,x:379.9,y:95.3},0).wait(2).to({rotation:-13.6,x:379.6,y:97.1},0).wait(2).to({rotation:-7.4,x:379.2,y:98.9},0).wait(82).to({scaleX:0.69,rotation:-20.3,x:387.3,y:96.2},0).wait(2).to({scaleX:0.56,rotation:-33.6,x:395.3,y:93.5},0).to({_off:true},2).wait(62).to({_off:false,scaleX:0.83,rotation:-7.4,x:379.2,y:98.9},0).wait(35));

	// Condor Wingspan Chest Feather 2
	this.condor_frontleg = new lib.CondorLeg();
	this.condor_frontleg.parent = this;
	this.condor_frontleg.setTransform(365.7,110.3,0.832,0.832,-7.4);

	this.condor_frontleg_1 = new lib.CondorWingspanChestFeather2_1();
	this.condor_frontleg_1.parent = this;
	this.condor_frontleg_1.setTransform(359,89,0.845,0.888,0,0,0,25.6,18.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.condor_frontleg}]}).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},10).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},6).to({state:[{t:this.condor_frontleg}]},10).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},82).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},38).to({state:[{t:this.condor_frontleg}]},14).to({state:[{t:this.condor_frontleg}]},26).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg}]},2).to({state:[{t:this.condor_frontleg_1,p:{regY:18.7,y:89}}]},2).to({state:[{t:this.condor_frontleg_1,p:{regY:18.5,y:86.2}}]},2).to({state:[{t:this.condor_frontleg_1,p:{regY:18.7,y:83.6}}]},2).to({state:[{t:this.condor_frontleg}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.condor_frontleg).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:0,skewX:-6.5,skewY:-7.3,x:366.2},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-5.8,x:366.8},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-4.2,x:367.9},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:365.7},0).wait(2).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(10).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(18).to({scaleX:0.83,scaleY:0.83,rotation:0,skewX:-6.5,skewY:-7.3,x:366.2},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-5.8,x:366.8},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-4.2,x:367.9},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:365.7},0).wait(2).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(82).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(82).to({scaleY:0.73,rotation:0,skewX:-0.1,skewY:-7.3,x:370.9,y:114.3},0).wait(2).to({scaleY:0.62,skewX:6.9,skewY:-7.4,x:376.3,y:118.3},0).to({_off:true},2).wait(62).to({_off:false,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:365.7,y:110.3},0).wait(35));

	// Condor Wingspan Chest Feathers 3
	this.instance_11 = new lib.CondorTorso_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(364.9,98.1,0.832,0.832,-7.4);

	this.instance_12 = new lib.CondorWingspanChestFeathers3_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(358.5,94.4,0.997,1.149,0,0,0,22.8,18.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_11}]}).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},10).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},6).to({state:[{t:this.instance_11}]},10).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},82).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},38).to({state:[{t:this.instance_11}]},14).to({state:[{t:this.instance_11}]},26).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_12,p:{y:94.4}}]},2).to({state:[{t:this.instance_12,p:{y:91.4}}]},2).to({state:[{t:this.instance_12,p:{y:88.4}}]},2).to({state:[{t:this.instance_11}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(2).to({rotation:-6.3,x:365.3,y:97.9},0).wait(2).to({rotation:-5.5,x:365.7,y:97.6},0).wait(2).to({rotation:-3.9,x:366.5,y:97.2},0).wait(2).to({rotation:-7.4,x:364.9,y:98.1},0).wait(2).to({rotation:-10.1,x:363.9,y:97.7},0).wait(2).to({rotation:-13,x:362.9,y:97.2},0).wait(2).to({rotation:-15.8,x:361.8,y:96.8},0).wait(10).to({rotation:-13,x:362.9,y:97.2},0).wait(2).to({rotation:-10.1,x:363.9,y:97.7},0).wait(2).to({rotation:-7.4,x:364.9,y:98.1},0).wait(18).to({rotation:-6.3,x:365.3,y:97.9},0).wait(2).to({rotation:-5.5,x:365.7,y:97.6},0).wait(2).to({rotation:-3.9,x:366.5,y:97.2},0).wait(2).to({rotation:-7.4,x:364.9,y:98.1},0).wait(2).to({rotation:-10.1,x:363.9,y:97.7},0).wait(2).to({rotation:-13,x:362.9,y:97.2},0).wait(2).to({rotation:-15.8,x:361.8,y:96.8},0).wait(82).to({rotation:-13,x:362.9,y:97.2},0).wait(2).to({rotation:-10.1,x:363.9,y:97.7},0).wait(2).to({rotation:-7.4,x:364.9,y:98.1},0).wait(82).to({scaleY:0.84,rotation:0,skewX:-3.6,skewY:-7.3,x:367.1,y:96.9},0).wait(2).to({scaleY:0.84,skewX:0,skewY:-7.4,x:369.3,y:95.7},0).to({_off:true},2).wait(62).to({_off:false,scaleY:0.83,rotation:-7.4,skewY:0,x:364.9,y:98.1},0).wait(35));

	// Condor Wingspan Torso
	this.condor_hindleg = new lib.CondorBackLeg();
	this.condor_hindleg.parent = this;
	this.condor_hindleg.setTransform(351.6,109.2,0.832,0.832,-7.4);

	this.condor_hindleg_1 = new lib.CondorWingspanTorso_1();
	this.condor_hindleg_1.parent = this;
	this.condor_hindleg_1.setTransform(358.8,84.9,0.888,0.888,0,0,0,26.2,42.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.condor_hindleg}]}).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},10).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},6).to({state:[{t:this.condor_hindleg}]},10).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},82).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},38).to({state:[{t:this.condor_hindleg}]},14).to({state:[{t:this.condor_hindleg}]},26).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg}]},2).to({state:[{t:this.condor_hindleg_1}]},2).to({state:[{t:this.condor_hindleg_1}]},2).to({state:[{t:this.condor_hindleg_1}]},2).to({state:[{t:this.condor_hindleg}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.condor_hindleg).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:0,skewX:-6.5,skewY:-7.3,x:352.2},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-5.8,x:352.8},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-4.2,x:353.9},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:351.6},0).wait(2).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(10).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(18).to({scaleX:0.83,scaleY:0.83,rotation:0,skewX:-6.5,skewY:-7.3,x:352.2},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-5.8,x:352.8},0).wait(2).to({scaleX:0.84,scaleY:0.83,skewX:-4.2,x:353.9},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:351.6},0).wait(2).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(82).to({rotation:-7.3},0).wait(4).to({rotation:-7.4},0).wait(82).to({scaleY:0.75,rotation:0,skewX:1.3,skewY:-7.3,x:354.1,y:112.9},0).wait(2).to({scaleY:0.67,skewX:10,skewY:-7.4,x:356.6,y:116.6},0).to({_off:true},2).wait(62).to({_off:false,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:351.6,y:109.2},0).wait(35));

	// Condor Wingspan Left Leg
	this.instance_13 = new lib.CondorTail_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(393.6,119.4,0.832,0.832,-7.4);

	this.instance_14 = new lib.CondorWingspanLeftLeg_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(370.9,125,0.888,0.888,0,0,0,12.6,27.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_13}]}).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},10).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},6).to({state:[{t:this.instance_13}]},10).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},82).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},2).to({state:[{t:this.instance_13}]},38).to({state:[{t:this.instance_13}]},14).to({state:[{t:this.instance_13}]},26).to({state:[{t:this.instance_13}]},2).to({state:[]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_13}]},58).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(2).to({rotation:-6.3,x:393.7,y:119.7},0).wait(2).to({rotation:-5.5,y:119.9},0).wait(2).to({rotation:-3.9,x:393.9,y:120.3},0).wait(2).to({rotation:-7.4,x:393.6,y:119.4},0).wait(2).to({scaleX:0.78,scaleY:0.83,rotation:0,skewX:-20.5,skewY:-17.6,x:396.9,y:118.1},0).wait(2).to({scaleX:0.72,skewX:-33.8,skewY:-28.1,x:400.3,y:116.6},0).wait(2).to({scaleX:0.67,scaleY:0.83,skewX:-47.1,skewY:-38.4,x:403.5,y:115.2},0).wait(10).to({scaleX:0.72,scaleY:0.83,skewX:-33.8,skewY:-28.1,x:400.3,y:116.6},0).wait(2).to({scaleX:0.78,skewX:-20.5,skewY:-17.6,x:396.9,y:118.1},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:393.6,y:119.4},0).wait(18).to({rotation:-6.3,x:393.7,y:119.7},0).wait(2).to({rotation:-5.5,y:119.9},0).wait(2).to({rotation:-3.9,x:393.9,y:120.3},0).wait(2).to({rotation:-7.4,x:393.6,y:119.4},0).wait(2).to({scaleX:0.78,scaleY:0.83,rotation:0,skewX:-20.5,skewY:-17.6,x:396.9,y:118.1},0).wait(2).to({scaleX:0.72,skewX:-33.8,skewY:-28.1,x:400.3,y:116.6},0).wait(2).to({scaleX:0.67,scaleY:0.83,skewX:-47.1,skewY:-38.4,x:403.5,y:115.2},0).wait(82).to({scaleX:0.72,scaleY:0.83,skewX:-33.8,skewY:-28.1,x:400.3,y:116.6},0).wait(2).to({scaleX:0.78,skewX:-20.5,skewY:-17.6,x:396.9,y:118.1},0).wait(2).to({scaleX:0.83,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:393.6,y:119.4},0).wait(82).to({scaleX:0.82,scaleY:0.74,rotation:0,skewX:-13.5,skewY:-6.5,x:391.3,y:116.1},0).to({_off:true},2).wait(64).to({_off:false,scaleX:0.83,scaleY:0.83,rotation:-7.4,skewX:0,skewY:0,x:393.6,y:119.4},0).wait(35));

	// Condor Wingspan Right Leg
	this.instance_15 = new lib.CondorWingspanRightLeg_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(347.7,124.3,0.888,0.888,0,0,0,12.6,27);
	this.instance_15._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(230).to({_off:false},0).wait(4).to({_off:true},58).wait(35));

	// Condor Wingspan Tail
	this.instance_16 = new lib.CondorWingspanTail_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(392.8,102.9,0.51,0.75,0,-20.1,0,50.9,5.8);
	this.instance_16._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(226).to({_off:false},0).wait(2).to({regX:30.7,scaleX:0.7,scaleY:0.81,skewX:-34.3,x:375.1,y:101.8},0).wait(2).to({regX:39.3,scaleX:0.89,scaleY:0.67,skewX:0,x:358.2,y:100.5},0).wait(2).to({scaleY:0.78,y:97.3},0).wait(2).to({scaleY:0.89,y:94},0).to({_off:true},58).wait(35));

	// Condor Wingspan Wing
	this.instance_17 = new lib.CondorWingspanWing_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(251.2,62.7,0.888,0.888,0,0,180,109.7,43.7);
	this.instance_17._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(234).to({_off:false},0).to({_off:true},58).wait(35));

	// Condor Wingspan Wing
	this.instance_18 = new lib.CondorWing();
	this.instance_18.parent = this;
	this.instance_18.setTransform(355.6,98,0.484,0.823,0,-12.2,-140);

	this.instance_19 = new lib.Tween1kh_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(353.3,97.7);

	this.instance_20 = new lib.Tween2khb_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(360.4,80.7);

	this.instance_21 = new lib.CondorWingspanWing_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(463.2,62.7,0.888,0.888,0,0,0,109.8,43.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_18,p:{scaleX:0.484,scaleY:0.823,skewX:-12.2,x:355.6,y:98}}]},226).to({state:[{t:this.instance_18,p:{scaleX:0.777,scaleY:0.832,skewX:-4.2,x:348.3,y:105}}]},2).to({state:[{t:this.instance_19}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_21}]},2).to({state:[]},58).wait(35));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(291.6,15.7,124.3,139.5);


(lib.condor = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// beakGlow
	this.beakGlow = new lib.condor_beakGlow();
	this.beakGlow.parent = this;
	this.beakGlow.setTransform(262.4,106.2,1,1,0,0,0,7.6,5.9);
	this.beakGlow.alpha = 0;
	this.beakGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.beakGlow.cache(-3,-3,22,19);

	this.timeline.addTween(cjs.Tween.get(this.beakGlow).wait(1));

	// neckGlow
	this.neckGlow = new lib.condor_neckGlow();
	this.neckGlow.parent = this;
	this.neckGlow.setTransform(291,123,1,1,0,0,0,11.2,16.9);
	this.neckGlow.alpha = 0;
	this.neckGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.neckGlow.cache(-3,5,26,31);

	this.timeline.addTween(cjs.Tween.get(this.neckGlow).wait(1));

	// backGlow
	this.backGlow = new lib.condor_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(328.8,161.4,0.955,0.986,0,0,0,27.9,29.8);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.backGlow.cache(-1,-1,57,57);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// footGlow
	this.footGlow = new lib.condor_footGlow();
	this.footGlow.parent = this;
	this.footGlow.setTransform(311.2,211.7,1.056,1.252,0,0,0,17.9,22.2);
	this.footGlow.alpha = 0;
	this.footGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.footGlow.cache(-2,4,42,26);

	this.timeline.addTween(cjs.Tween.get(this.footGlow).wait(1));

	// back1
	this.beak = new lib.invisiblebox();
	this.beak.parent = this;
	this.beak.setTransform(263.6,105.6,0.531,0.463);

	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(290.1,126.2,0.564,0.63);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(299.6,170.4,0.465,1.122,-38.7);

	this.foot = new lib.invisiblebox();
	this.foot.parent = this;
	this.foot.setTransform(308.8,210,0.975,0.544,-0.9);

	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(346.6,199.1,0.676,0.583);

	this.back1 = new lib.invisiblebox();
	this.back1.parent = this;
	this.back1.setTransform(330.3,159.1,0.549,1.364,-41);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.back1},{t:this.tail},{t:this.foot},{t:this.tummy},{t:this.neck},{t:this.beak}]}).wait(1));

	// main
	this.main = new lib.Condor();
	this.main.parent = this;
	this.main.setTransform(-29.7,124.3,1,1,0,0,0,20.4,55.5);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.condor, new cjs.Rectangle(241.5,84.5,124.3,140.1), null);


// stage content:
(lib.MWcondor = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWcondor_atlas_.png?1528310537635", id:"MWcondor_atlas_"}
	],
	preloads: []
};




})(lib_Condor = lib_Condor||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Condor, images, createjs, ss, AdobeAn;